import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule, LOCALE_ID, DEFAULT_CURRENCY_CODE} from '@angular/core';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {CommonModule, registerLocaleData, DatePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import localeFr from '@angular/common/locales/fr';

registerLocaleData(localeFr);
import {NgSelectModule} from '@ng-select/ng-select';
import {NgxSliderModule} from '@angular-slider/ngx-slider';
import {NgxSpinnerModule, NgxSpinnerService} from "ngx-spinner";
import {NgxPaginationModule} from 'ngx-pagination';
import {NgPipesModule} from 'ngx-pipes';
import {TreeviewModule} from 'ngx-treeview';
import {InterceptorService} from './services/interceptor.service';
import {ApiToolsService} from './services/api-tools.service';
import {ConfirmDialogService} from './services/confirm-dialog.service';
import {SharedToolsService} from './services/shared-tools.service';
import {DataInitService} from "./services/data-init.service";
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {GoogleMapsModule} from '@angular/google-maps'
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ModalComponent} from './modal/modal.component';
import {LoginComponent} from './login/login.component';
import {HeaderComponent} from './header/header.component';
import {FooterComponent} from './footer/footer.component';
import {MdpRappelComponent} from './mdp-rappel/mdp-rappel.component';
import {MdpReinitComponent} from './mdp-reinit/mdp-reinit.component';
import {BatimentComponent} from './batiment/batiment.component';
import {WelcomeComponent} from './welcome/welcome.component';
import {BlocHeadInfoComponent} from './bloc-head-info/bloc-head-info.component';
import {SidebarRecapComponent} from './sidebar-recap/sidebar-recap.component';
import {SidebarMenuComponent} from './sidebar-menu/sidebar-menu.component';
import {BreadcrumbComponent} from './breadcrumb/breadcrumb.component';
import {ChoixRenovComponent} from './choix-renov/choix-renov.component';
import {ChoixRenovBisComponent} from './choix-renov-bis/choix-renov-bis.component';
import {PiecesComponent} from './pieces/pieces.component';
import {EstimationRapideComponent} from './estimation-rapide/estimation-rapide.component';
import {PieceParPieceComponent} from './piece-par-piece/piece-par-piece.component';
import {ModalMeublesCuisineComponent} from './modal-meubles-cuisine/modal-meubles-cuisine.component';
import {ModalRecopierComponent} from './modal-recopier/modal-recopier.component';
import {ModalAutresFinitionsComponent} from './modal-autres-finitions/modal-autres-finitions.component';
import {ModalReglagesComponent} from './modal-reglages/modal-reglages.component';
import {ModalLoaderEstimationComponent} from './modal-loader-estimation/modal-loader-estimation.component';
import {ModalNbNiveauxComponent} from "./modal-nb-niveaux/modal-nb-niveaux.component";
import {MonCompteComponent} from './mon-compte/mon-compte.component';
import {SidebarBoComponent} from './sidebar-bo/sidebar-bo.component';
import {AgentsComponent} from './agents/agents.component';
import {EstimationsComponent} from './estimations/estimations.component';
import {ClientsComponent} from './clients/clients.component';
import {AgencesComponent} from './agences/agences.component';
import {ModalAddUserComponent} from './modal-add-user/modal-add-user.component';
import {ModalAddAgencyComponent} from './modal-add-agency/modal-add-agency.component';
import {TutorielsComponent} from './tutoriels/tutoriels.component';
import {ProduitsComponent} from './produits/produits.component';
import {InscriptionComponent} from './inscription/inscription.component';
import {TransactionComponent} from './transaction/transaction.component';
import {ModalScenarioNrjComponent} from './modal-scenario-nrj/modal-scenario-nrj.component';
import {PartenairesComponent} from './partenaires/partenaires.component';
import {ModalInscriptionComponent} from './modal-inscription/modal-inscription.component';
import {FormInscriptionComponent} from './form-inscription/form-inscription.component';
import {SignOnComponent} from './sign-on/sign-on.component';
import {TooltipDirective} from './directives/tooltip.directive';
import {AllUsersComponent} from './all-users/all-users.component';
import {ContactExterneComponent} from './contact-externe/contact-externe.component';
import {FormContactExterneComponent} from './form-contact-externe/form-contact-externe.component';
import { ModalAdminAddUserComponent } from './modal-admin-add-user/modal-admin-add-user.component';

@NgModule({
	declarations: [
		AppComponent,
		ModalComponent,
		LoginComponent,
		HeaderComponent,
		FooterComponent,
		MdpRappelComponent,
		MdpReinitComponent,
		BatimentComponent,
		WelcomeComponent,
		BlocHeadInfoComponent,
		SidebarRecapComponent,
		SidebarMenuComponent,
		BreadcrumbComponent,
		ChoixRenovComponent,
		ChoixRenovBisComponent,
		PiecesComponent,
		EstimationRapideComponent,
		PieceParPieceComponent,
		ModalMeublesCuisineComponent,
		ModalRecopierComponent,
		ModalAutresFinitionsComponent,
		ModalReglagesComponent,
		ModalLoaderEstimationComponent,
		ModalNbNiveauxComponent,
		MonCompteComponent,
		SidebarBoComponent,
		AgentsComponent,
		EstimationsComponent,
		ClientsComponent,
		AgencesComponent,
		ModalAddUserComponent,
		ModalAddAgencyComponent,
		TutorielsComponent,
		ProduitsComponent,
		InscriptionComponent,
		TransactionComponent,
		ModalScenarioNrjComponent,
		PartenairesComponent,
		ModalInscriptionComponent,
		FormInscriptionComponent,
		SignOnComponent,
		TooltipDirective,
		AllUsersComponent,
		ContactExterneComponent,
		FormContactExterneComponent,
  ModalAdminAddUserComponent
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		HttpClientModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgSelectModule,
		NgxSliderModule,
		NgxSpinnerModule,
		NgPipesModule,
		NgxPaginationModule,
		SlickCarouselModule,
		GoogleMapsModule,
		TreeviewModule.forRoot()
	],
	providers: [
		{provide: LOCALE_ID, useValue: 'fr-FR'},
		{provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR'},
		{provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true},
		NgxSpinnerService,
		ApiToolsService,
		SharedToolsService,
		DataInitService,
		ConfirmDialogService,
		DatePipe,
		BatimentComponent,
		WelcomeComponent,
		BlocHeadInfoComponent,
		SidebarRecapComponent,
		SidebarMenuComponent,
		BreadcrumbComponent,
		ChoixRenovComponent,
		ChoixRenovBisComponent,
		PiecesComponent,
		EstimationRapideComponent,
		PartenairesComponent
	],
	bootstrap: [AppComponent]
})
export class AppModule {
}
